import React, { useEffect } from 'react'
import {
  Box,
  Container,
  Typography
} from '@mui/material'
import { ChronoPageHeader } from '@/layouts/core/components/ChronoPageHeader'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { EventPanel } from '@/modules/event/components/EventPanel'
import { useDispatch } from 'react-redux'
import { setEvent } from '@/modules/event/eventSlice'
import { createLogger } from '@/common/logger'
import { ChronoPageProps } from '@/modules/shared/types/shared'

const logger = createLogger({ prefix: 'ChronoPage' })

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '98vh',
    alignContent: 'space-between'
  },
  header: {},
  content: {},
  footer: {
    paddingTop: 30,
    paddingBottom: 30,
    [theme.breakpoints.down('sm')]: {},
    [theme.breakpoints.up('sm')]: {},
  },
  footerSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center'
    },
    [theme.breakpoints.up('sm')]: {},
  },
}))

const FooterItem = ({ label, children, sx }: { label?: string | React.ReactNode, children: string | React.ReactNode, sx?: any }) => {
  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} sx={sx}>
      {label &&
        <Typography fontWeight={'bold'} variant={'body2'} marginRight={1}>{label}</Typography>
      }
      <Typography variant={'body2'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        {children}
      </Typography>
    </Box>
  )
}

const ChronoPage = (props: ChronoPageProps) => {
  const dispatch = useDispatch()
  const { header, label, controls, event, children } = props
  const classes = useStyles()

  useEffect(() => {
    dispatch(setEvent(event))
  }, [dispatch, event])

  useEffect(() => {
    logger.debug('Mounting ChronoPage instance', props)
    // any lifecycle behavior here? 
    return () => {
      logger.debug('Un-mounting ChronoPage instance', props)
    }
  })

  return (
    <Container>
      <Box
        data-cy={props['data-cy']}
        className={`ct-container ${classes.container}`}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}>

        <Box className={`ct-header ${classes.header}`} flexGrow={1}>
          <ChronoPageHeader>
            {header}
          </ChronoPageHeader>
        </Box>

        <Box className={`ct-content ${classes.content}`} flexGrow={10}>

          {event &&
            <Box
              marginTop={0}
              paddingLeft={1}
              paddingRight={2}>

              <EventPanel event={event} />
            </Box>
          }

          <Box
            marginTop={3}
            paddingLeft={1}
            paddingRight={2}
            display={'flex'}
            justifyContent={'space-between'}>

            <Typography variant={'h5'}>
              {label}
            </Typography>

            {controls}
          </Box>

          <Box
            marginTop={3}
            paddingRight={2}
            paddingLeft={1}
            paddingTop={1}
            paddingBottom={1}>

            {children}

          </Box>


        </Box>

        <Box
          className={`ct-footer ${classes.footer}`}
          display={'flex'}
          flexDirection={'column'}
          flexGrow={1}
          alignItems={'center'}>

          {/*
          <Box className={`${classes.footerSubContainer}`}>

            <FooterItem label={'Support E-Mail'} sx={{ marginRight: 3 }}>
              <a href={'mailto:regsupport@chronotrack.com'} target={'_blank'} rel={'noreferrer'}>
                regsupport@chronotrack.com
              </a>
            </FooterItem>
            <FooterItem label={'Support Phone'}>
              <a href={'tel:1-888-600-2298'} target={'_blank'} rel={'noreferrer'}>
                1-888-600-2298
              </a>
            </FooterItem>

          </Box>
*/}

          <Box className={`${classes.footerSubContainer}`}>
            <FooterItem>
              &copy;2009-2022 ChronoTrack.&nbsp;&nbsp;
              All rights reserved.&nbsp;&nbsp;
            </FooterItem>
            <FooterItem>
              <a
                target={'_blank'}
                rel='noreferrer'
                href={'https://www.athlinks.com/privacy'}
              >Privacy Policy</a>
              &nbsp;&amp;&nbsp;
              <a
                target={'_blank'}
                rel='noreferrer'
                href={'https://www.athlinks.com/terms'}
              >Terms of Service</a>
            </FooterItem>
          </Box>

        </Box>
      </Box>


    </Container>
  )
}

export default ChronoPage